import { bustUrlCache } from '../helpers/bustUrlCache';
import { getExoSkeletonRemotesUrl } from '../helpers/getExoSkeletonRemotesUrl';
import { promiseWithRetries } from '../helpers/promiseWithRetries';
export async function fetchRemotes() {
  let {
    transformRemotesUrl
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let remotesUrl = getExoSkeletonRemotesUrl();
  if (transformRemotesUrl) {
    remotesUrl = transformRemotesUrl(remotesUrl);
  }
  return promiseWithRetries(_ref => {
    let {
      attempt
    } = _ref;
    return fetch(attempt > 1 ? bustUrlCache(remotesUrl) : remotesUrl).then(response => {
      if (!response.ok) {
        throw new Error("Failed to fetch remotes: \"".concat(response.statusText, "\""));
      }
      return response.json();
    });
  }, {
    retries: 3
  });
}
//# sourceMappingURL=fetch.js.map